export interface Props {
	children?: any
	className?: string
	padding?: boolean
}

export const Container = ({children, className, padding}: Props) => {
	return (
		<div className={['relative container mx-auto', className, padding && 'px-4 xl:px-8'].join(" ")}>
			{ children }
		</div>
	)
}
